import { Endpoint } from '../endpoint';
import { CustomTabFilesResponse, CustomTabId, CustomTabResponse } from '@business/entities/custom-tab';

export function fetchProfileTabs() {
  return Endpoint.get<CustomTabResponse[]>(`@gc/custom-tabs`);
}

export function createTab(data: Partial<CustomTabResponse>) {
  return Endpoint.post<CustomTabResponse>(`@gc/custom-tabs`, { data });
}

export function updateTab(id: CustomTabId, data: Partial<CustomTabResponse>) {
  return Endpoint.patch<CustomTabResponse>(`@gc/custom-tabs/${id}`, { data });
}

export function deleteTab(id: CustomTabId) {
  return Endpoint.delete<CustomTabResponse>(`@gc/custom-tabs/${id}`);
}

export function formValueSave(id: string, data: Partial<{}>) {
  return Endpoint.post<CustomTabFilesResponse>(`@gc/custom-tabs/save-values/${id}`, { data });
}
